

import matchResultHeader from '../components/MatchResultHeader.vue'
import matchMoments from './matchMoments.vue'
import Vue from 'vue'
import Scroller from 'vux/src/components/scroller/index.vue'

export default {
computed: {},
components: {
matchResultHeader,
matchMoments,
Scroller
},
methods: {},
mounted(){
this.eventHub.$on('resetView',()=>{
this.$nextTick(() => {
this.$refs.scroller.reset();
})
})
},
data () {
return {
eventHub: new Vue(),
}
}
}



// WEBPACK FOOTER //
// ./src/views/momentList.vue